import styled from "styled-components";
export const HeaderWrap = styled.div`
    background: var(--white);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    box-shadow: 0px 0px 6px 0px #0000001c;
    padding: 20px 20px 20px 50px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: 0.5s ease;
    z-index: 9;

    @media (min-width: 992px) {
        left: 90px;
        padding: 20px 40px;
    }
    @media (min-width: 768px) {
        padding: 20px 40px 20px 50px;
    }

    .collapsed & {
        @media (min-width: 992px) {
            left: 240px;
        }
    }

    input {
        @media (max-width: 575px) {
            width: 200px;
        }
    }

    .navLinks {
        display: flex;
        align-items: center;
        gap: 20px;
        @media (min-width: 576px) {
            gap: 30px;
        }

        .bellDrop {
            position: relative;
            cursor: pointer;
            .notification {
                position: relative;
                margin-top: 10px;
                font-size: 24px;
                span {
                    position: absolute;
                    top: -17px;
                    right: -9px;
                    width: 17px;
                    height: 17px;
                    z-index: 9;
                    background-color: ${({theme}) => theme?.light?.primary};
                    font-size: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    color: var(--white);
                }
            }
        }
        .btnHolder {
            display: flex;
            cursor: pointer;
            position: relative;
            .textWrap {
                min-height: 50px;
                padding: 6px 15px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                background-color: ${({theme}) => theme?.light?.primary};
                border-radius: 14px 0px 0px 14px;
                width: 180px;
                display: flex;
                align-items: center;

                @media (max-width: 767px) {
                    display: none;
                }
                strong {
                    display: block;
                    font-size: 16px;
                    line-height: 20px;
                    color: var(--white);
                    font-weight: 400;
                }
                span {
                    display: block;
                    font-size: 14px;
                    line-height: 18px;
                    color: var(--white);
                    font-weight: 300;
                }
            }
            .imgWrap {
                position: absolute;
                right: -22px;
                top: 0;
                width: 50px;
                height: 50px;
                overflow: hidden;
                border-radius: 50%;
                @media (max-width: 767px) {
                    position: static;
                    width: 40px;
                    height: 40px;
                }
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
    .user-dropdown {
        width: 180px;
        top: 60px;
    }
`;
export const DropDown = styled.div`
    position: absolute;
    top: 45px;
    right: 0;
    padding: 0;
    max-height: 450px;
    overflow: hidden;
    background-color: var(--white);
    width: 380px;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px) scale(0.95);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(0, 0, 0, 0.05);
    
    &.active {
        opacity: 1;
        visibility: visible;
        transform: translateY(0) scale(1);
    }

    /* Scrollbar styling */
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #e0e0e0;
        border-radius: 10px;
        
        &:hover {
            background: #c0c0c0;
        }
    }

    /* Notification header */
    .notification-header {
        padding: 16px 20px;
        border-bottom: 1px solid #f0f0f0;
        background: linear-gradient(to bottom, #fafafa, #ffffff);
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        h3 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #1a1a1a;
        }
    }

    /* Scrollable content area */
    #fetchMore {
        max-height: 380px;
        overflow-y: auto;
        padding: 8px 0;
    }

    .col {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 14px 20px;
        cursor: pointer;
        transition: all 0.2s ease;
        border-left: 3px solid transparent;
        position: relative;
        
        &:hover {
            background-color: #f8f9fa;
            border-left-color: ${({theme}) => theme?.light?.primary || '#ff6b35'};
        }

        &:not(:last-child) {
            border-bottom: 1px solid #f5f5f5;
        }

        /* Unread notification styling */
        &.unread-notification {
            background-color: #fef9f5;
            
            &:hover {
                background-color: #fef5ed;
            }
        }
    }

    .notification-icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-size: 18px;
        background: linear-gradient(135deg, ${({theme}) => theme?.light?.primary || '#ff6b35'} 0%, ${({theme}) => theme?.light?.secondary || '#ff8c5a'} 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(255, 107, 53, 0.2);
    }

    .img-holder {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .unread {
        height: 8px;
        width: 8px;
        border-radius: 50%;
        flex-shrink: 0;
        background-color: ${({theme}) => theme?.light?.primary || '#ff6b35'};
        box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.1);
        position: absolute;
        top: 20px;
        right: 20px;
    }

    .delete-icon {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background-color: #fff;
        color: #dc3545;
        font-size: 18px;
        cursor: pointer;
        transition: all 0.2s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        z-index: 10;
        
        &:hover {
            background-color: #dc3545;
            color: #fff;
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
            transform: translateY(-50%) scale(1.1);
        }
        
        &:active {
            transform: translateY(-50%) scale(0.95);
        }
    }

    .content-holder {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        flex: 1;
        
        > div {
            flex: 1;
        }
    }

    .heading {
        display: block;
        font-size: 14px;
        line-height: 20px;
        margin: 0 0 4px;
        font-weight: 500;
        color: #1a1a1a;
        word-break: break-word;
    }

    .date-time {
        display: block;
        font-size: 12px;
        line-height: 16px;
        color: #888;
        margin: 0;
        font-weight: 400;
    }

    .logout {
        color: var(--danger);
    }

    .mark-all-read {
        padding: 12px 20px;
        text-align: center;
        font-size: 13px;
        font-weight: 600;
        color: ${({theme}) => theme?.light?.primary || '#ff6b35'};
        cursor: pointer;
        border-bottom: 1px solid #f0f0f0;
        background: #fafafa;
        transition: all 0.2s;
        letter-spacing: 0.3px;
        text-transform: uppercase;

        &:hover {
            background: #f5f5f5;
            color: ${({theme}) => theme?.light?.secondary || '#ff8c5a'};
        }
    }

    .infinite-scroll-text {
        display: block;
        text-align: center;
        padding: 20px;
        font-size: 13px;
        color: #999;
        font-style: italic;
    }

    .empty-state {
        text-align: center;
        padding: 40px 20px;
        color: #999;
        
        .empty-icon {
            font-size: 48px;
            margin-bottom: 16px;
            opacity: 0.3;
        }
        
        p {
            margin: 0;
            font-size: 14px;
            line-height: 20px;
        }
    }

    /* User dropdown specific styles */
    &.user-dropdown {
        width: 200px;
        padding: 8px 0;
        
        .col {
            padding: 12px 16px;
            border-left: none;
            
            &:hover {
                background-color: #f5f5f5;
            }
        }
        
        .icon-holder {
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            img {
                width: 16px;
                height: 16px;
            }
        }
        
        .heading {
            font-size: 14px;
            margin: 0;
            font-weight: 500;
        }
    }
`;
